export class VobAssignmentUpdateCommand {
    upn: string;
    assignmentType: string;
    processType: string;
    assignmentValues: string[];

    constructor(upn: string, assignmentType: string, processType: string, assignmentValues: string[]) {
        this.upn = upn;
        this.assignmentType = assignmentType;
        this.processType = processType;
        this.assignmentValues = assignmentValues;
    }
}
